import type { PeerCursor } from './usePeerCursors';

export function PeerCursorsOverlay({ peers }: { peers: PeerCursor[] }) {
  if (peers.length === 0) return null;

  return (
    <div style={{ position: 'absolute', top: 12, right: 12, zIndex: 100, display: 'flex', gap: 6 }}>
      {peers.map((peer) => (
        <div
          key={peer.id}
          style={{
            padding: '3px 8px',
            borderRadius: 999,
            background: 'rgba(13,17,23,0.85)',
            border: `1px solid ${peer.color}`,
            color: peer.color,
            fontSize: 11,
            fontWeight: 600,
            display: 'flex',
            alignItems: 'center',
            gap: 6,
          }}
        >
          <span style={{ width: 6, height: 6, borderRadius: '50%', background: peer.color }} />
          {peer.name}
          {peer.selection.length > 0 && (
            <span style={{ opacity: 0.7, fontWeight: 400 }}>
              · {peer.selection.length} selected
            </span>
          )}
        </div>
      ))}
    </div>
  );
}
